import http from './request'

// 获取用户任务列表
export const getWaRecallTasks = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/getTasks',
    method: 'post',
    data
  })
}

// 获取召回的消息信息(用于发送wa）
export const getWaRecallMessageInfo = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/getWaRecallMessageInfo',
    method: 'post',
    data
  })
}

// 获取wa召回活动用户信息
export const getWaRecallUserInfo = (data) => {
  return http({
    url: '/promotion/WaRecallActivityUser/getInfo',
    method: 'post',
    data
  })
}

// 完成视频上传任务
export const completeWaRecallTask = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/completeTask',
    method: 'post',
    data
  })
}

// 领取奖励
export const claimWaRecallReward = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/claimTaskReward',
    method: 'post',
    data
  })
}

// 获取wa拉新任务记录
export const getWaInviteActivityList = (data) => {
  return http({
    url: '/promotion/WaInviteActivity/getPagedList',
    method: 'post',
    data
  })
}

// 获取wa拉新发送信息
export const getInviteMessageInfo = (data) => {
  return http({
    url: '/promotion/WaInviteActivity/getInviteMessageInfo',
    method: 'post',
    data
  })
}
